import AjaxManager from "../ajaxManager";
import Form from "../../entity/form";
import SliderManager from "../slider/sliderManager";
import HotelRoomManager from "../hotelRoom/hotelRoomManager";
import CaptchaManager from "../captcha/captchaManager";
import Select2Manager from "../select2Manager";

var ContactUsManager = function () {

    var self = this;
    this.ajaxManager = new AjaxManager();
    this.captchaManager = new CaptchaManager();
    this.select2Manager = new Select2Manager();

    this.initialize = function () {
        this.eventDelegation();
        new HotelRoomManager();
        this.captchaManager.captchaInitialize($('#provider-contact-form'));
    };

    this.eventDelegation = function () {

        $('[data-action="check-booking"]').on('click',  (e) => {
            let form = $('#booking-contact');

            let formValidation = form.data('formValidation');
            formValidation.validate();

            if (formValidation.isValid()) {
                myApp.customerDataValidator.validateBooking((response) =>  {
                    if (response.status && response.url) {
                        window.location.href = response.url;
                    }else{
                        let contactError = $('[data-contact=error]');
                        contactError.html(response.message)
                        contactError.show();
                    }
                });
            }
        });

        $('[data-contact=help-options]').on('change', function () {
            self.selectHelpOption(this);
        });

        $("body").on("click", "[data-remove=traveller]", function () {
            self.removeTraveller(this);
            self.setPeople();
            self.recalculateRoomDistribution();
        });

        $("body").on("click", "[data-add=traveller]", function () {
            self.addTraveller();
            self.setPeople();
            self.recalculateRoomDistribution();
        });

        $("body").on("change", "[data-traveller-age]", function () {
            self.setPeople();
            self.recalculateRoomDistribution();
        });

        $("body").on("click", "[data-element=contact-selector]", function (e) {
            var clickedButton = this;
            var nonClickedButton = $(clickedButton).siblings('[data-element=contact-selector]');
            var focusOfNonClickedButton = $($(nonClickedButton).data('target'));

            if ($(focusOfNonClickedButton).hasClass('collapsing')) {
                e.stopPropagation();
            }

            $('#provider-reporter-panel').hide();
            $('[data-result=option],[data-result=summary]').empty();
        });

        $("body").on("select2:select", "#chollos-list", function () {
            self.selectChollo($(this).val());
        });

        $("body").on("change", "#chollos-list-mobile", function () {
            self.selectChollo($(this).val());
        });

        $("#provider-reporter-panel").on('click', '[data-toggle=collapse]', function (e) {
            var href = $(this).attr('href');
            var coordinates = href === "#provider-contact-form" ? $(this).position() : $(href).position();

            window.scrollTo(coordinates.left, coordinates.top);
            e.preventDefault();
        });

        $("body").on("click", "[data-combination]", function () {
            $('[data-roomdistribution]').val($(this).data('combination'));
        });

        $('body').on('click', '[data-action="submit-form"]', function (e) {
            $('#'+$(this).data('form')).submit();
        });

        $('body').on('submit', '#generic-request', function (e) {
            self.sendGenericRequest(e, this);
        });

        $('body').on('input', '#generic_request_question', function (e) {
            if ($(this).val().length > 0) {
                $('[data-action="submit-form"]').prop('disabled', false);
            } else {
                $('[data-action="submit-form"]').prop('disabled', true);
            }
        });
    };

    this.selectHelpOption = function (option) {
        var form = $(option).parents('form');
        var formValidation = form.data('formValidation');
        var formObj = new Form(form.attr('id'));
        formValidation.validate();

        if ($(option).val() != 0 && formValidation.isValid() && !form.data('contact-nobooking')) {
            var validBooking = myApp.customerDataValidator.validateBooking(function (response) {
                if (response.status == true) {
                    $('[data-contact=error]').hide();
                    self.showSelectedHelpOption($("option:selected", option), response.token);
                    myApp.customerDataValidator.getBooking(response.token, $(option).val());
                    formObj.disableFields('[data-container=customer-data]');
                } else {
                    $('[data-result=loading]').hide();
                    $('[data-contact=error]').show().children('span').text(response.message);
                }
            });
        } else if ($(option).val() != 0 && $(option).parents('form').data('contact-nobooking') && formValidation.isValid()) {
            self.showSelectedHelpOption($("option:selected", option));
            formObj.disableFields('[data-container=customer-data]');
        } else if ($(option).val() == 0) {
            $('[data-container=help-result]').children().empty();
            formObj.enableFields('[data-container=customer-data]');

        }
    };

    this.showSelectedHelpOption = function (option, token) {
        var url, type, data, callback, id_reserva;
        let inputUserLoggedId = $('#userLoggedId');
        url = option.data('action');

        if (!$(option).parents('form').data('contact-nobooking')) {
            id_reserva = $('[data-contact=idbooking]').val();
        }

        type = 'POST';
        data = {
            nombre: $('[name="nombre"]').val(),
            apellidos: $('[name="apellidos"]').val(),
            email: $('[name="email2"]').val(),
            telefono: $('[name="telefono"]').val(),
            privacy_agreement: $('[name="confirmo"]').val(),
            id_reserva: id_reserva,
            token: token
        };

        if (inputUserLoggedId.length > 0) {
            data['userLoggedId'] = inputUserLoggedId.val();
        }

        callback = function callback(data) {
            $('[data-result=loading]').hide();
            $('[data-container=help-result]').children('[data-result=option]').html(data);
            if (option.val() == 1) {
                myApp.bookingDatepickerConfigurator.initializeBookingDatepickers("new-start-date", "new-end-date");
            }

            if (option.data('load') === "custom-modal") {
                myApp.customModalManager.reinitialize('[data-load="custom-modal"]')
            }

            myApp.formSubmitterManager.initialize();

            self.select2Manager.initialize();
        };
        self.ajaxManager.ajaxCall(type, url, data, callback);
    };

    this.recalculateRoomDistribution = function () {
        var url, type, data, callback, array_ages = [];

        $("[data-traveller-age]").each(function (index) {
            if ($(this).val() != 'adulto') {
                array_ages.push($(this).val());
            }
        });

        url = myApp.config.routing.recalculateRoomDistribution;
        type = 'POST';
        data = {
            id_booking: $('[data-contact=idbooking]').val(),
            num_people: $('[name=npers]').val(),
            num_children: $('[name=nnens]').val(),
            children_age: array_ages,
            token: $('[name=token]').val()
        };
        callback = function callback(data) {
            $('[data-other-information=response]').html(data);
            myApp.config.hotelId = $('[name="hotel"]').val();
            let sliderManager = new SliderManager();
            sliderManager.addSlider('[data-entity="slider"]', null, 'bullets');

            $('[data-combination]').click((event) => {
                const currentTarget = event.currentTarget;
                if (currentTarget.dataset.roomDataSheet) {
                    return;
                }

                const currentCombination = document.querySelector('[data-combination].combination-active');
                if (currentCombination) {
                    currentCombination.classList.remove('combination-active');
                }

                currentTarget.classList.add('combination-active');
                $('[data-roomdistribution]').val($(currentTarget).data('combination'));
            });
        };
        self.ajaxManager.ajaxCall(type, url, data, callback);
    };

    this.removeTraveller = function (elem) {
        $($(elem).data('remove-element')).remove();
    };


    this.setPeople = function () {
        var numAdults = 1;
        var numChildren = 0;
        $("[data-traveller-age]:visible").each(function (index) {
            if ($(this).val() == 'adulto') {
                numAdults++;
            } else {
                numChildren++;
            }
        });
        $('[name=npers]').val(numAdults);
        $('[name=nnens]').val(numChildren);
    };

    this.addTraveller = function (elem) {
        var cloned = $("[data-traveller-original]").clone();
        var num = $('[data-travellers-count]').attr('data-travellers-count');
        cloned.find('input').val('');
        cloned.find('select').val('adulto');
        cloned.show();
        cloned.removeAttr('data-traveller-original');
        cloned.find('[name=nom_]').attr('name', 'nom_' + num);
        cloned.find('[name=cognom1_]').attr('name', 'cognom1_' + num);
        cloned.find('[name=cognom2_]').attr('name', 'cognom2_' + num);
        cloned.find('[name=edad_]').attr('name', 'edad_' + num);
        cloned.find('[data-remove-element]').attr('data-remove-element', '[data-traveller-container=traveller' + num + ']');
        cloned.attr('data-traveller-container', 'traveller' + num);
        $('[data-travellers-count]').attr('data-travellers-count', (parseInt(num) + 1));
        $('[name="max_id_persona"]').val(parseInt(num) + 1);
        cloned.appendTo('[data-container=traveller]');
        $('#modify-travellers').formValidation('addField', 'nom_' + num);
        $('#modify-travellers').formValidation('addField', 'cognom1_' + num);
    };

    this.selectChollo = function (idChollo) {
        var url, type, data, callback;

        url = myApp.config.routing.selectChollo;
        type = 'POST';
        data = {
            nombre: $('[name="nombre"]').val(),
            apellidos: $('[name="apellidos"]').val(),
            email: $('[name="email2"]').val(),
            telefono: $('[name="telefono"]').val(),
            privacy_agreement: $('[name="confirmo"]').val(),
            id_grupo: idChollo,
            mas_noches: $('[name="mas_noches"]').val()
        };

        callback = function callback(data) {
            $('[data-information-chollo=response]').html(data);
            myApp.bookingDatepickerConfigurator.initializeBookingDatepickers("no-booking-start-date", "no-booking-end-date");
            myApp.formSubmitterManager.initialize();
        };
        self.ajaxManager.ajaxCall(type, url, data, callback);
    };

    this.sendGenericRequest =  function (e, form) {
        e.preventDefault();
        let formData = new FormData(form);
        let promise = new Promise(function(resolve, reject) {
            $.ajax({
                type: 'POST',
                url: myApp.config.routing.contact.sendGenericRequest,
                data: formData,
                dataType: "JSON",
                contentType: false,
                cache: false,
                processData: false
            }).done(function(data) {
                if (data.status == 0) {
                    resolve();
                } else {
                    reject(Error(data.error));
                }
            });
        });

        promise.then(function(result) {
            $('#cancel_booking_output').html('<div class="alert alert-success margin-top-10"><i class="ci ci-circle-check"></i>' + myApp.translator['alert.question.sent.ok'] + '</div>');
            $('#cancel_booking_output').show();
            myApp.customModalManager.closeModal('#general_request_modal');
            setTimeout(function () {
                $('#cancel_booking_output').fadeOut(2000)
            }, 5000);
        }, function(err) {
            $('#cancel_booking_output').html('<div class="alert alert-danger margin-top-10"><i class="ci ci-fire"></i>' + myApp.translator['alert.question.not.sent'] + '</div>');
            $('#cancel_booking_output').show();
            myApp.customModalManager.closeModal('#general_request_modal');
            setTimeout(function () {
                $('#cancel_booking_output').fadeOut(2000)
            }, 5000);
        });

        return false;
    }

    this.generateContactOptions = function (select) {
        $('[data-contact=error]').hide();
        var formValidation = $(select).parents('form').data('formValidation');
        formValidation.validate();

        if (!formValidation.isValid()) {
            return;
        }

        var bookingId = $('[data-contact="idbooking"]').val();
        var dni = $('[data-contact="dni"]').val();
        var email = $('[data-contact="email"]').val();
        if (!bookingId) {
            return;
        }

        var data = {
            'bookingId': bookingId,
            'dni': dni,
            'email': email
        };

        self.ajaxManager.ajaxCall(
            'POST',
            myApp.config.routing.contact.optionsGenerator,
            data,
            function (response) {
                if (response.error === 0) {
                    $("#booking-contact-options option").each(function () {
                        if ($.inArray(parseInt($(this).val()), response.options) < 0) {
                            $(this).remove();
                        }
                    });
                } else {
                    $('[data-contact=error]').show().children('span').text(response.message);
                }
            });
    };

    this.initialize();
};

export default ContactUsManager;
